import { i18n } from '../templatesI18n.ts';
// Icons merged here from templateIcons.ts
// Light theme icons
import BrainstormingLight from '../assets/icons-light/Brainstorming.svg';
import BrainstormingLightHover from '../assets/icons-light/Brainstorming-Hover.svg';
import BusinessStatusUpdateLight from '../assets/icons-light/Business-Status-Update.svg';
import BusinessStatusUpdateLightHover from '../assets/icons-light/Business-Status-Update-Hover.svg';
import DACILight from '../assets/icons-light/DACI.svg';
import DACILightHover from '../assets/icons-light/DACI-Hover.svg';
import DesignDecisionLight from '../assets/icons-light/Design-Decision.svg';
import DesignDecisionLightHover from '../assets/icons-light/Design-Decision-Hover.svg';
import DesignSprintLight from '../assets/icons-light/Design-Sprint.svg';
import DesignSprintLightHover from '../assets/icons-light/Design-Sprint-Hover.svg';
import EmployeeHandbookLight from '../assets/icons-light/Employee-Handbook.svg';
import EmployeeHandbookLightHover from '../assets/icons-light/Employee-Handbook-Hover.svg';
import FundraisingLight from '../assets/icons-light/Fundraising.svg';
import FundraisingDatabaseLightHover from '../assets/icons-light/Fundraising-Database-Hover.svg';
import HiringProcessLight from '../assets/icons-light/Hiring-Process.svg';
import HiringProcessLightHover from '../assets/icons-light/Hiring-Process-Hover.svg';
import ITSMRunbookLight from '../assets/icons-light/ITSM-Runbook.svg';
import ITSMRunbookLightHover from '../assets/icons-light/ITSM-Runbook-Hover.svg';
import MarketingCampaignLight from '../assets/icons-light/Marketing-Campaign.svg';
import MarketingCampaignLightHover from '../assets/icons-light/Marketing-Campaign-Hover.svg';
import OKRTrackingLight from '../assets/icons-light/OKR-Tracking.svg';
import OKRTrackingLightHover from '../assets/icons-light/OKR-Tracking-Hover.svg';
import MeetingNotesLight from '../assets/icons-light/Meeting-notes.svg';
import MeetingNotesLightHover from '../assets/icons-light/Meeting-notes-Hover.svg';
import MarketingPlanLight from '../assets/icons-light/Mkt-Plan.svg';
import MarketingPlanLightHover from '../assets/icons-light/Mkt-Plan-Hover.svg';
import ProductRequirementsLight from '../assets/icons-light/PRD.svg';
import ProductRequirementsLightHover from '../assets/icons-light/PRD-Hover.svg';
import ProjectPlanLight from '../assets/icons-light/Project-Plan.svg';
import ProjectPlanLightHover from '../assets/icons-light/Project-Plan-Hover.svg';
import ProjectStatusReportLight from '../assets/icons-light/Proj-Status-Report.svg';
import ProjectStatusReportLightHover from '../assets/icons-light/Project-Status-Hover.svg';
import RetrospectiveLight from '../assets/icons-light/Retro.svg';
import RetrospectiveLightHover from '../assets/icons-light/Retro-Hover.svg';
import SalesAccountPlanningLight from '../assets/icons-light/Sales-Account-Planning.svg';
import SalesAccountPlanningLightHover from '../assets/icons-light/Sales-Account-Planning-Hover.svg';
import SalesPortalLight from '../assets/icons-light/Sales-Portal.svg';
import SalesPortalLightHover from '../assets/icons-light/Sales-Portal-Hover.svg';
import SoftwareArchitectureReviewLight from '../assets/icons-light/Software-Arch-Review.svg';
import SoftwareArchitectureReviewLightHover from '../assets/icons-light/Software-Arch-Review-Hover.svg';
import TroubleshootingArticleLight from '../assets/icons-light/Troubleshooting-Article.svg';
import TroubleshootingArticleLightHover from '../assets/icons-light/Troubleshooting-Article-Hover.svg';
// Dark theme icons
import BrainstormingDark from '../assets/icons-dark/Brainstorming.svg';
import BrainstormingDarkHover from '../assets/icons-dark/Brainstorming-Hover.svg';
import BusinessStatusUpdateDark from '../assets/icons-dark/Business-Status-Update.svg';
import BusinessStatusUpdateDarkHover from '../assets/icons-dark/Business-Status-Update-Hover.svg';
import DACIDark from '../assets/icons-dark/DACI.svg';
import DACIDarkHover from '../assets/icons-dark/DACI-Hover.svg';
import DesignDecisionDark from '../assets/icons-dark/Design-Decision.svg';
import DesignDecisionDarkHover from '../assets/icons-dark/Design-Decision-Hover.svg';
import DesignSprintDark from '../assets/icons-dark/Design-Sprint.svg';
import DesignSprintDarkHover from '../assets/icons-dark/Design-Sprint-Hover.svg';
import EmployeeHandbookDark from '../assets/icons-dark/Employee-Handbook.svg';
import EmployeeHandbookDarkHover from '../assets/icons-dark/Employee-Handbook-Hover.svg';
import FundraisingDark from '../assets/icons-dark/Fundraising.svg';
import FundraisingDatabaseDarkHover from '../assets/icons-dark/Fundraising-Database-Hover.svg';
import HiringProcessDark from '../assets/icons-dark/Hiring-Process.svg';
import HiringProcessDarkHover from '../assets/icons-dark/Hiring-Process-Hover.svg';
import ITSMRunbookDark from '../assets/icons-dark/ITSM-Runbook.svg';
import ITSMRunbookDarkHover from '../assets/icons-dark/ITSM-Runbook-Hover.svg';
import MarketingCampaignDark from '../assets/icons-dark/Marketing-Campaign.svg';
import MarketingCampaignDarkHover from '../assets/icons-dark/Marketing-Campaign-Hover.svg';
import OKRTrackingDark from '../assets/icons-dark/OKR-Tracking.svg';
import OKRTrackingDarkHover from '../assets/icons-dark/OKR-Tracking-Hover.svg';
import MeetingNotesDark from '../assets/icons-dark/Meeting-notes.svg';
import MeetingNotesDarkHover from '../assets/icons-dark/Meeting-notes-Hover.svg';
import MarketingPlanDark from '../assets/icons-dark/Mkt-Plan.svg';
import MarketingPlanDarkHover from '../assets/icons-dark/Mkt-Plan-Hover.svg';
import ProductRequirementsDark from '../assets/icons-dark/PRD.svg';
import ProductRequirementsDarkHover from '../assets/icons-dark/PRD-Hover.svg';
import ProjectPlanDark from '../assets/icons-dark/Project-Plan.svg';
import ProjectPlanDarkHover from '../assets/icons-dark/Project-Plan-Hover.svg';
import ProjectStatusReportDark from '../assets/icons-dark/Proj-Status-Report.svg';
import ProjectStatusReportDarkHover from '../assets/icons-dark/Project-Status-Hover.svg';
import RetrospectiveDark from '../assets/icons-dark/Retro.svg';
import RetrospectiveDarkHover from '../assets/icons-dark/Retro-Hover.svg';
import SalesAccountPlanningDark from '../assets/icons-dark/Sales-Account-Planning.svg';
import SalesAccountPlanningDarkHover from '../assets/icons-dark/Sales-Account-Planning-Hover.svg';
import SalesPortalDark from '../assets/icons-dark/Sales-Portal.svg';
import SalesPortalDarkHover from '../assets/icons-dark/Sales-Portal-Hover.svg';
import SoftwareArchitectureReviewDark from '../assets/icons-dark/Software-Arch-Review.svg';
import SoftwareArchitectureReviewDarkHover from '../assets/icons-dark/Software-Arch-Review-Hover.svg';
import TroubleshootingArticleDark from '../assets/icons-dark/Troubleshooting-Article.svg';
import TroubleshootingArticleDarkHover from '../assets/icons-dark/Troubleshooting-Article-Hover.svg';

// TEMPLATE_ICONS removed; icons are inlined into TEMPLATE_DETAILS.
export type TemplateName = keyof typeof TEMPLATE_DETAILS;
export type TemplateDetails = (typeof TEMPLATE_DETAILS)[TemplateName];
export type TeamType =
	| 'Software development'
	| 'Product management'
	| 'Finance'
	| 'Human resources'
	| 'Legal'
	| 'Marketing'
	| 'Operations'
	| 'Sales'
	| 'Design'
	| 'Project management'
	| 'IT support';

export const DEFAULT_TEMPLATES: [TemplateName, TemplateName, TemplateName] = [
	'Project plan',
	'Meeting notes',
	'Brainstorming',
];

export const TEMPLATES_FOR_TEAM_TYPE: Record<TeamType, [TemplateName, TemplateName, TemplateName]> =
	{
		'Software development': ['Software Architecture Review', 'Meeting notes', 'Retrospective'],
		'Product management': ['Product Requirements', 'Meeting notes', 'Brainstorming'],
		Finance: ['Business status update', 'Meeting notes', 'Fundraising database'],
		'Human resources': ['Employee handbook', 'Meeting notes', 'Hiring Process Template'],
		Legal: ['Project plan', 'Meeting notes', 'DACI: Decision documentation'],
		Marketing: ['Marketing campaign', 'Meeting notes', 'Marketing plan'],
		Operations: ['Standard Operating Procedure (SOP) Template', 'Meeting notes', 'Project plan'],
		Sales: ['Sales account planning', 'Meeting notes', 'Sales portal'],
		Design: ['Design decision', 'Meeting notes', 'Design sprint'],
		'Project management': ['Project plan', 'Meeting notes', 'Project status report'],
		'IT support': ['Troubleshooting article', 'Meeting notes', 'ITSM runbook'],
	} as const;

export const TEMPLATE_DETAILS: {
	readonly Brainstorming: {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Business status update': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'DACI: Decision documentation': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Design decision': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Design sprint': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Employee handbook': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Fundraising database': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:fundraising-database-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Hiring Process Template': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'ITSM runbook': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Marketing campaign': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Marketing plan': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Meeting notes': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Product Requirements': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Project plan': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Project status report': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly Retrospective: {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Sales account planning': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Sales portal': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Software Architecture Review': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Standard Operating Procedure (SOP) Template': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
	readonly 'Troubleshooting article': {
		readonly blueprintModuleCompleteKey: 'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint';
		readonly name: {
			id: string;
			defaultMessage: string;
			description: string;
		};
		readonly icons: {
			readonly light: {
				readonly normal: any;
				readonly hover: any;
			};
			readonly dark: {
				readonly normal: any;
				readonly hover: any;
			};
		};
	};
} = {
	Brainstorming: {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:brainstorming-with-remote-teams-blueprint',
		name: i18n.brainstormingTemplateName,
		icons: {
			light: { normal: BrainstormingLight, hover: BrainstormingLightHover },
			dark: { normal: BrainstormingDark, hover: BrainstormingDarkHover },
		},
	},
	'Business status update': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:business-status-update-blueprint',
		name: i18n.businesStatusUpdateTemplateName,
		icons: {
			light: { normal: BusinessStatusUpdateLight, hover: BusinessStatusUpdateLightHover },
			dark: { normal: BusinessStatusUpdateDark, hover: BusinessStatusUpdateDarkHover },
		},
	},
	'DACI: Decision documentation': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:decisions-blueprint',
		name: i18n.DACIDecisionDocumentTemplateName,
		icons: {
			light: { normal: DACILight, hover: DACILightHover },
			dark: { normal: DACIDark, hover: DACIDarkHover },
		},
	},
	'Design decision': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:design-decision-blueprint',
		name: i18n.designDecisionTemplateName,
		icons: {
			light: { normal: DesignDecisionLight, hover: DesignDecisionLightHover },
			dark: { normal: DesignDecisionDark, hover: DesignDecisionDarkHover },
		},
	},
	'Design sprint': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:design-sprint-blueprint',
		name: i18n.designSprintTemplateName,
		icons: {
			light: { normal: DesignSprintLight, hover: DesignSprintLightHover },
			dark: { normal: DesignSprintDark, hover: DesignSprintDarkHover },
		},
	},
	'Employee handbook': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:employee-handbook-blueprint',
		name: i18n.employeeHandbookTemplateName,
		icons: {
			light: { normal: EmployeeHandbookLight, hover: EmployeeHandbookLightHover },
			dark: { normal: EmployeeHandbookDark, hover: EmployeeHandbookDarkHover },
		},
	},
	'Fundraising database': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:fundraising-database-blueprint',
		name: i18n.fundraisingDatabaseTemplateName,
		icons: {
			light: { normal: FundraisingLight, hover: FundraisingDatabaseLightHover },
			dark: { normal: FundraisingDark, hover: FundraisingDatabaseDarkHover },
		},
	},
	'Hiring Process Template': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:hiring-process-blueprint',
		name: i18n.hiringProcessTemplateName,
		icons: {
			light: { normal: HiringProcessLight, hover: HiringProcessLightHover },
			dark: { normal: HiringProcessDark, hover: HiringProcessDarkHover },
		},
	},
	'ITSM runbook': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:itsm-runbook-blueprint',
		name: i18n.ITSMRunbookTemplateName,
		icons: {
			light: { normal: ITSMRunbookLight, hover: ITSMRunbookLightHover },
			dark: { normal: ITSMRunbookDark, hover: ITSMRunbookDarkHover },
		},
	},
	'Marketing campaign': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-campaign-blueprint',
		name: i18n.marketingCampaignTemplateName,
		icons: {
			light: { normal: MarketingCampaignLight, hover: MarketingCampaignLightHover },
			dark: { normal: MarketingCampaignDark, hover: MarketingCampaignDarkHover },
		},
	},
	'Marketing plan': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:marketing-blueprint',
		name: i18n.marketingPlanTemplateName,
		icons: {
			light: { normal: MarketingPlanLight, hover: MarketingPlanLightHover },
			dark: { normal: MarketingPlanDark, hover: MarketingPlanDarkHover },
		},
	},
	'Meeting notes': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:meeting-notes-blueprint',
		name: i18n.meetingNotesTemplateName,
		icons: {
			light: { normal: MeetingNotesLight, hover: MeetingNotesLightHover },
			dark: { normal: MeetingNotesDark, hover: MeetingNotesDarkHover },
		},
	},
	'Product Requirements': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-software-blueprints:requirements-blueprint',
		name: i18n.productRequirementsTemplateName,
		icons: {
			light: { normal: ProductRequirementsLight, hover: ProductRequirementsLightHover },
			dark: { normal: ProductRequirementsDark, hover: ProductRequirementsDarkHover },
		},
	},
	'Project plan': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:projectplan-blueprint',
		name: i18n.projectPlanTemplateName,
		icons: {
			light: { normal: ProjectPlanLight, hover: ProjectPlanLightHover },
			dark: { normal: ProjectPlanDark, hover: ProjectPlanDarkHover },
		},
	},
	'Project status report': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:project-status-blueprint',
		name: i18n.projectStatusTemplateName,
		icons: {
			light: { normal: ProjectStatusReportLight, hover: ProjectStatusReportLightHover },
			dark: { normal: ProjectStatusReportDark, hover: ProjectStatusReportDarkHover },
		},
	},
	Retrospective: {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint',
		name: i18n.retrospectiveTemplateName,
		icons: {
			light: { normal: RetrospectiveLight, hover: RetrospectiveLightHover },
			dark: { normal: RetrospectiveDark, hover: RetrospectiveDarkHover },
		},
	},
	'Sales account planning': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:account-planning-for-sales-blueprint',
		name: i18n.salesAccountPlanningTemplateName,
		icons: {
			light: { normal: SalesAccountPlanningLight, hover: SalesAccountPlanningLightHover },
			dark: { normal: SalesAccountPlanningDark, hover: SalesAccountPlanningDarkHover },
		},
	},
	'Sales portal': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:sales-portal-template-blueprint',
		name: i18n.salesPortalTemplateName,
		icons: {
			light: { normal: SalesPortalLight, hover: SalesPortalLightHover },
			dark: { normal: SalesPortalDark, hover: SalesPortalDarkHover },
		},
	},
	'Software Architecture Review': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:software-architecture-review-blueprint',
		name: i18n.softwareArchitectureReviewTemplateName,
		icons: {
			light: {
				normal: SoftwareArchitectureReviewLight,
				hover: SoftwareArchitectureReviewLightHover,
			},
			dark: { normal: SoftwareArchitectureReviewDark, hover: SoftwareArchitectureReviewDarkHover },
		},
	},
	'Standard Operating Procedure (SOP) Template': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-business-blueprints:standard-operating-procedure-sop-blueprint',
		name: i18n.standardOperatingProcedureTemplateName,
		icons: {
			light: { normal: OKRTrackingLight, hover: OKRTrackingLightHover },
			dark: { normal: OKRTrackingDark, hover: OKRTrackingDarkHover },
		},
	},
	'Troubleshooting article': {
		blueprintModuleCompleteKey:
			'com.atlassian.confluence.plugins.confluence-knowledge-base:kb-troubleshooting-article-blueprint',
		name: i18n.troubleshootingArticleTemplateName,
		icons: {
			light: { normal: TroubleshootingArticleLight, hover: TroubleshootingArticleLightHover },
			dark: { normal: TroubleshootingArticleDark, hover: TroubleshootingArticleDarkHover },
		},
	},
} as const;
